import { Button } from "antd";
import React, { useState } from "react";

const parameters = [
  { id: 1, name: "Parameter 1", issue: "Issue with calibration" },
  { id: 2, name: "Parameter 2", issue: "Incorrect threshold values" },
  { id: 3, name: "Parameter 3", issue: "Sensor misalignment detected" },
];

const enclosures = [
  { id: 1, name: "Enclosure 1", pdfUrl: "/pdfs/enclosure1.pdf" },
  { id: 2, name: "Enclosure 2", pdfUrl: "/pdfs/enclosure2.pdf" },
  { id: 3, name: "Enclosure 3", pdfUrl: "/pdfs/enclosure3.pdf" },
];

const RectificationComponent: React.FC = () => {
  const [inputValue, setInputValue] = useState("");
  const [error, setError] = useState("");
  const [comment, setComment] = useState<string>("");

  const [paramIndex, setParamIndex] = useState(0);
  const [enclosureIndex, setEnclosureIndex] = useState(0);

  const nextParam = () => {
    setParamIndex((prev) => (prev + 1) % parameters.length);
  };

  const prevParam = () => {
    setParamIndex((prev) => (prev - 1 + parameters.length) % parameters.length);
  };

  const nextEnclosure = () => {
    setEnclosureIndex((prev) => (prev + 1) % enclosures.length);
  };

  const prevEnclosure = () => {
    setEnclosureIndex(
      (prev) => (prev - 1 + enclosures.length) % enclosures.length
    );
  };

  const handleRectify = () => {
    // if (!inputValue.trim()) {
    //   setError('Input cannot be empty');
    //   return;
    // }
    // setError('');
    // onSubmit(inputValue.trim());
  };

  return (
    <div className="container-fluid">
      <div className="page-wrapper">
        <div className="card mt-3">
          <div className="card-body">
            <div className="text fs-18 fw-bold">
              Review Corrected Parameters and Updated Documents -
              <span className="fs-14 fw-normal">
                {" "}
                Examine the rectified parameters and uploaded documents, and
                provide necessary comments.
              </span>
              <div className="fs-18 fw-bold text-info">
                Steps for Review:-
                <ul className="list-unstyled mt-2">
                  <li className="fs-14">
                    🔹{" "}
                    <span>
                      Examine the rectified parameters and uploaded documents.
                    </span>
                  </li>
                  <li className="fs-14">
                    🔹{" "}
                    <span>
                      Provide necessary comments and forward for DR review.
                    </span>
                  </li>
                </ul>
              </div>
              <div className="row ">
                <div className="col-md-6 border p-1">
                  Examine Details
                  <div className="container ">
                    {/* Parameters Section */}
                    {/* <h4 className="text-primary fw-bold">Parameters</h4> */}
                    <div className="d-flex justify-content-between align-items-center ">
                      <Button type="default" onClick={prevParam}>
                        ◀ Prev
                      </Button>
                      <div className="d-flex align-items-center gap-2">
                        <h6 className="fw-bold">
                          {parameters[paramIndex].name}
                        </h6>
                        <div className="text-danger fs-13">
                          {parameters[paramIndex].issue}
                        </div>
                      </div>
                      <Button type="default" onClick={nextParam}>
                        Next ▶
                      </Button>
                    </div>

                    {/* Enclosures Section */}
                    {/* <h4 className="text-primary fw-bold mt-4">Enclosures</h4> */}
                    <div className="d-flex justify-content-between align-items-center ">
                      <Button type="default" onClick={prevEnclosure}>
                        ◀ Prev
                      </Button>
                      <div className="d-flex align-items-center gap-2">
                        <h6 className="fw-bold">
                          {enclosures[enclosureIndex].name}
                        </h6>
                        <span>
                          <Button
                            type="default"
                            href={enclosures[enclosureIndex].pdfUrl}
                            target="_blank"
                          >
                            View PDF
                          </Button>
                        </span>
                      </div>
                      <Button type="default" onClick={nextEnclosure}>
                        Next ▶
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 border p-1 ml-1">
                  Add Comments
                  <div className="row mt-2">
                    <div className="col-md-6 ">
                      <input
                        type="text"
                        className="form-control "
                        placeholder="Enter your comment..."
                        //   height={9}
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                      />
                    </div>

                    <div className="col-md-4">
                      <button className="btn btn-info w-100">
                        Forward For DR Review
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RectificationComponent;
